import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'

import ab from './ab'
import addressUpdate from '../components/AddressUpdate/redux/reducers'
import addressValidation from './addressValidation'
import addToLook from './addToLook'
import api from './api'
import blackDesk from './blackDesk'
import checkout from './checkout'
import dashboard from './dashboard'
import eventMgr from './eventMgr'
import events from './events'
import fit from './fit'
import fitProfile from './fitProfile'
import form from './form'
import groomRentsFree from './groomRentsFree'
import helloBar from './helloBar'
import kickbox from './kickbox'
import lookbuilder from './lookbuilder'
import looks from './looks'
import mobileMenu from './mobileMenu'
import onboarding from '../components/Onboarding/redux/reducers'
import orders from './orders'
import pane from './pane'
import people from './people'
import postCheckout from './postCheckout'
import product from './product'
import productCategoryPage from './productCategoryPage'
import productDetailPage from './productDetailPage'
import promo from './promo'
import receipt from './receipt'
import rentToKeep from './rentToKeep'
import replacements from './replacements'
import reviews from './reviews'
import nearestShowrooms from './nearestShowrooms'
import showrooms from './showrooms'
import showroomAppointments from './showroomAppointments'
import showroomLocations from './showroomLocations'
import site from './site'
import sizes from './sizes'
import user from './user'
import userInteractions from './userInteractions'
import worldpay from './worldpay'
import addItems from '../pages/OrderManager/CheckoutAddItem/PaymentStep/redux/reducer'

export default (history) =>
  combineReducers({
    ab,
    addressUpdate,
    addressValidation,
    addToLook,
    api,
    blackDesk,
    checkout,
    dashboard,
    eventMgr,
    events,
    fit,
    fitProfile,
    groomRentsFree,
    helloBar,
    form,
    kickbox,
    lookbuilder,
    looks,
    mobileMenu,
    nearestShowrooms,
    onboarding,
    orders,
    reviews,
    pane,
    productCategoryPage,
    productDetailPage,
    promo,
    people,
    postCheckout,
    product,
    receipt,
    rentToKeep,
    replacements,
    router: connectRouter(history),
    showrooms,
    showroomAppointments,
    showroomLocations,
    site,
    sizes,
    user,
    userInteractions,
    worldpay,
    addItems,
  })
